import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Modal, Spin } from "antd";
import ReactDiffViewer from "react-diff-viewer";
import { useDeviceType } from "../../../../../hooks/useDeviceType.js";
import { useTranslation } from "../../../../../others/i18n.js";
import { DeviceType } from "../../../../../types/device/device.js";
const TemplateDiff = ({ open, onOk, onCancel, left, right, title, loading, ...restProps })=>{
    const { t } = useTranslation();
    const device = useDeviceType();
    return /*#__PURE__*/ _jsx(Modal, {
        title: title || t(`Compare template changes`),
        open: open,
        onOk: onOk,
        width: "90%",
        bodyStyle: {
            maxHeight: DeviceType.isBigScreen(device) ? "75vh" : "65vh",
            overflowY: "auto"
        },
        footer: [
            /*#__PURE__*/ _jsx(Button, {
                type: "primary",
                onClick: onOk,
                children: t("Close")
            }, "ok")
        ],
        onCancel: onCancel,
        closable: true,
        ...restProps,
        children: /*#__PURE__*/ _jsx(Spin, {
            delay: 1000,
            spinning: loading,
            children: /*#__PURE__*/ _jsx(ReactDiffViewer, {
                oldValue: left,
                newValue: right,
                leftTitle: t("Previous Version"),
                rightTitle: t("Release Version")
            })
        })
    });
};
export { TemplateDiff };
